export const programsData = [
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/bachelor-of-business-administration-online",
                "ProgramType": "UG_Program",
                "Heading": "Bachelor of Business Administration",
                "CourseStripText": "Top UG Program",
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "379",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8244",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Bachelor_of_Business_Administration_d46771c48e.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Bachelor of Business Administration (BBA)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "BACHELOR OF BUSINESS ADMINISTRATION",
                    "target": [
                        "_self"
                    ],
                    "alt": "BACHELOR OF BUSINESS ADMINISTRATION",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Program_919ef7c9c1_53009a56d1.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/master-of-business-administration-online",
                "ProgramType": "PG_Program",
                "Heading": "Master of Business Administration",
                "CourseStripText": "QS Ranked",
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "3227",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/years_40683bcf2d_5d79dc2c4d.svg",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "9854",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Master_of_Business_Administration_2b444be7d2_cf2b3ad261.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Master of Business Administration (  Online MBA )",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Master of Business Administration ( Online MBA)",
                    "target": [
                        "_self"
                    ],
                    "alt": "Group",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_dbdb7b7343.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/bachelor-of-computer-applications-online",
                "ProgramType": "UG_Program",
                "Heading": "Bachelor of Computer Applications",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "379",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8276",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Bachelor_of_Computer_Applications_8dd37b71ed.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Bachelor of Computer Applications (BCA)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Bachelor of Computer Applications ",
                    "target": [
                        "_self"
                    ],
                    "alt": "Bachelor of Computer Applications ",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_f011b06199.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/master-of-computer-applications-online",
                "ProgramType": "PG_Program",
                "Heading": "Master of Computer Applications",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "158",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/years_40683bcf2d.svg",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8359",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Master_of_Computer_Applications_2a376aee25.jpg"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Master of Computer Applications (MCA)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Master of Computer Applications",
                    "target": [
                        "_self"
                    ],
                    "alt": "Master of Computer Applications",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100220_378a46643d.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/bachelor-of-commerce-online",
                "ProgramType": "UG_Program",
                "Heading": "Bachelor of Commerce",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "379",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8265",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/bachor_of_Commerce_6a60abbe68.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Bachelor of Commerce",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Bachelor of\nCommerce",
                    "target": [
                        "_self"
                    ],
                    "alt": "Bachelor of Commerce",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100243_438c08dd11.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/bachelor-of-arts-online",
                "ProgramType": "UG_Program",
                "Heading": "Bachelor of Arts",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "379",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8271",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Bachelor_of_Arts_2c9b1db4e0.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Bachelor of Arts (BA)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Bachelor of \nArts",
                    "target": [
                        "_self"
                    ],
                    "alt": "Bachelor of  Arts",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100243_50a0301c51.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/bachelor-of-arts-journalism-and-mass-communication-online",
                "ProgramType": "UG_Program",
                "Heading": "Bachelor of Arts (Journalism and Mass Communication)",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "379",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8274",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Bachelor_of_Arts_Journalism_and_Mass_Communication_f544e388de.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Bachelor of Arts (Journalism and Mass Communication) (BAJMC)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Bachelor of Arts (Journalism and Mass Communication)",
                    "target": null,
                    "alt": "Bachelor of Arts (Journalism and Mass Communication)",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100243_da0f8c5b12.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/master-of-arts-journalism-and-mass-communication-online",
                "ProgramType": "PG_Program",
                "Heading": "Master of Arts (Journalism and Mass Communication)",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "158",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/years_40683bcf2d.svg",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8239",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/master_of_Arts_Journalism_and_Mass_Communication_027aa52438.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Master of Arts (Journalism and Mass Communication) (MAJMC)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Master of Arts (Journalism and Mass Communication)",
                    "target": null,
                    "alt": "Master of Arts (Journalism and Mass Communication)",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100400_e1bb89563f.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/ma-public-policy",
                "ProgramType": "PG_Program",
                "Heading": "Master of Arts (Public Policy & Governance)",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "158",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/years_40683bcf2d.svg",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8236",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Master_of_Arts_Public_Policy_and_Governance_f71d9ef75d.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Master of Arts (Public Policy & Governance) ( MAPPG)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Master of Arts (Public Policy & Governance)",
                    "target": null,
                    "alt": "Master of Arts (Public Policy & Governance)",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100400_d4dca6f2ec.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    },
    {
        "attributes": {
            "BasicDetails": {
                "__typename": "ComponentCommonMenuDetails",
                "enabled": true,
                "url_key": "/master-of-commerce-financial-management-online",
                "ProgramType": "PG_Program",
                "Heading": "Master of Commerce (Financial Management)",
                "CourseStripText": null,
                "YearsIcon": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "158",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/years_40683bcf2d.svg",
                                    "width": 45,
                                    "height": 49
                                }
                            }
                        ]
                    }
                },
                "Image": {
                    "__typename": "ComponentCommonImage",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "id": "8259",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "alternativeText": null,
                                    "url": "https://amityonline.com/_s/Master_of_Commerce_Financial_Management_9ff210b2df.webp"
                                }
                            }
                        ]
                    }
                },
                "TrendingType": null,
                "Title": "Master of Commerce (Financial Management) (M.Com)",
                "Icon": {
                    "__typename": "ComponentCommonImage",
                    "enabled": true,
                    "title": "Master of Commerce (Financial Management)",
                    "target": [
                        "_self"
                    ],
                    "alt": "Master of Commerce (Financial Management)",
                    "source": {
                        "__typename": "UploadFileRelationResponseCollection",
                        "data": [
                            {
                                "__typename": "UploadFileEntity",
                                "attributes": {
                                    "__typename": "UploadFile",
                                    "url": "https://amityonline.com/_sb/Group_48100244_145c9e69a0.svg"
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
]